import React from 'react'
import Icon from './icon'
import { goBack } from '../../router'
import { withRouter } from 'react-router-dom'

/**
 * @param showBackButton: Boolean = false
 * @param [children]: String
 */
class HeadingComponent extends React.Component
{

    render()
    {
        let backButton = null
        if (this.props.showBackButton) {
            backButton = (<Icon>chevron_left</Icon>)
        }
        return (
            <div 
                onClick={ () => {
                    if (this.props.showBackButton) {
                        goBack(this.props.history)
                    }
                } }
                style={ this.props.style } 
                className={ "dk-heading " + (this.props.className || "") }>
                { backButton }
                { this.props.children }
            </div>
        )
    }

}

const Heading = withRouter(HeadingComponent)

export default Heading
export { Heading }